const getProposalForm = () => {
  const match = $("form.new_proposal,form.edit_proposal").first();
  if (match.length <= 0) {
    return null;
  }
  return match;
};
export default getProposalForm;
